import React, { useEffect, useState } from "react";
import useCollapse from "react-collapsed";

import "./collapsible.scss";

function Collapsible({
    title,
    subtext,
    errorText,
    children,
    expanded,
    className,
    textColor,
    logo,
    onClickArrow,
    isSubtext=false,
    isEligibility=false,
    isErrorInfo=false,
    isIconVisible=true,
    link = false,
}) {
    const [isExpanded, setExpanded] = useState(expanded || false);

    const { getCollapseProps, getToggleProps } = useCollapse({
        isExpanded: isExpanded,
    });

    const handleClick = () => {
        if (onClickArrow) {
            onClickArrow();
        }
    };

    useEffect(() => {
        setExpanded(expanded); 
      }, [expanded]);

    return (
        <div className={`collapsible ${className} ${
            isSubtext && !isExpanded ? "mb-4" : ""
        }`}>
            <div aria-label="button" onClick={handleClick}>
                <div
                    {...(onClickArrow
                        ? null
                        : {
                              ...getToggleProps({
                                  onClick: () =>
                                      setExpanded(
                                          (prevExpanded) => !prevExpanded
                                      ),
                              }),
                          })}
                    className={`d-flex justify-content-between ${isSubtext ? "align-items-start" : "align-items-center"} cursor-pointer`}
                >
                    <div className="d-flex align-items-center">
                        {logo && (
                            <div className="logo-section me-3 me-lg-4">
                                <img
                                    src={`/images/vectors/${logo}`}
                                    alt="collapsible-logo"
                                    width={34}
                                    height={34}
                                ></img>
                            </div>
                        )}
                        {isSubtext ? 
                            <div className="d-flex flex-column">
                                <div className="d-flex flex-column flex-lg-row gap-1 gap-lg-5 align-items-lg-center">
                                    <h3
                                        className={`${textColor} fw-bold mb-0 text-truncate ${
                                            logo ? "long" : "short"
                                        }`}
                                    >
                                        {title}
                                    </h3> 
                                    <p className="fw-bold rounded-1 error-text-bg mb-2 px-2 w-fit">{errorText}</p>
                                </div>
                                <p className="text-gray-1 mb-3">
                                    {subtext}
                                </p>
                            </div> 
                        : <h3
                            className={`${textColor} fw-bold mb-0 text-truncate ${
                                logo ? "long" : "short"
                            }`}
                        >
                            {title}
                        </h3>}
                    </div>
                    {isIconVisible ? 
                        <img
                            src={isEligibility ? "/images/vectors/down-black.svg" : "/images/vectors/down-primary.svg"}
                            alt=""
                            style={{
                                transform: link
                                    ? isExpanded
                                        ? "rotate(360deg)"
                                        : "rotate(270deg)"
                                    : isExpanded
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                transition: "0.3s",
                            }}
                        /> 
                        : <></> 
                    }
                </div>
                <div className={isErrorInfo ? 'mt-2': 'mt-4'} {...getCollapseProps()}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Collapsible;
